import React, { forwardRef } from "react";
import logoutIcon from "../../assets/icons/logout-red.svg";

const AvatarDropdown = forwardRef(({ onLogout, isRemixer, remixer }, ref) => (
  <div
    ref={ref}
    className="absolute right-0 top-full mt-2 w-[248px] bg-[#0B0D12] rounded-[15px] shadow-[0px_16px_42.5px_rgba(0,0,0,0.25)] p-2 flex flex-col gap-[26px] z-50 transition-all duration-300"
  >
    {isRemixer ? (
      // If it's a remixer, show remixer detail
      <div className="flex items-center gap-2 px-2 border-b border-[#2A2A2A] pb-2">
        <div className="flex flex-col">
          <span className="text-white font-bold text-[16px] leading-[19px] -tracking-wide">
            {remixer?.remixerName}
          </span>
          <span className="mt-1 text-[#828282] text-[12px] leading-[14px]">
            {remixer?.email || "No Email"}
          </span>
        </div>
      </div>
    ) : (
      // Admin details if not remixer
      <div className="flex items-center gap-2 px-2 border-b border-[#2A2A2A] pb-2">
        <div className="flex flex-col">
          <span className="text-white font-bold text-[16px] leading-[19px] -tracking-wide">
            Admin Supreme Edits
          </span>
          <span className="mt-1 text-[#828282] text-[12px] leading-[14px]">
            support@supremeedits.com
          </span>
        </div>
      </div>
    )}

    <div className="flex flex-col gap-[12px] px-2">
      <div className="p-[1px] mt-5 mb-2 w-full rounded-[12px] bg-[linear-gradient(90deg,_#1D1D1D,_#4B4949)]">
        <button
          onClick={onLogout}
          className="flex items-center gap-3 w-full h-[39px] px-2 py-[10px] rounded-[12px] text-[#FF543E] bg-[#111] hover:bg-[#1A1A1A] transition-all duration-300"
        >
          <img src={logoutIcon} alt="Logout" className="w-[16px] h-[16px]" />
          Log Out
        </button>
      </div>
    </div>
  </div>
));

export default AvatarDropdown;
